export const email = {
  from: "De",
  to: "Para",
  cc: "Cc",
  subject: "Assunto",
  noSubject: "(Sem assunto)",
  unknownSender: "Remetente desconhecido",
  attachments: "%{count} anexo |||| %{count} anexos",
  messageCount: "%{count} mensagem |||| %{count} mensagens",
  reply: "Responder",
  replyAll: "Responder a todos",
  forward: "Encaminhar",
  replyingTo: "Respondendo a",
  composeMessage: "Escreva sua mensagem...",
  sendHint: "Ctrl+Enter para enviar",
  enterUrl: "Digite a URL",
  invalidUrl: "URL inválida. Apenas URLs http/https são permitidas.",
  comingSoon: "Em breve",
};
